const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
    button: '[button-wishlist]',
    grid: '[grid-wishlist]',
    productCard: '.product-card',
};

document.addEventListener('DOMContentLoaded', () => {
    initButtons();
    initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
    console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
    initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
    console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
    console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

jQuery( document ).ready(function() {
    //TODO - Init buttons when product list refreshed
    //jQuery('#ShopProducts').on('DOMSubtreeModified', function(){
    /* Only add the first after change, then no work
    jQuery(document).on('change', '#ShopProducts', function() {
        initButtons();
        initGrid();
    });
    */
});

const fetchProductCardHTML = (handle) => {
    let productHTML = '';

    jQuery.getJSON('/products/'+handle+'.js', function(product) {
        productHTML += '<div class="product-card" data-wishlist-added="wishlist-'+product.id+'">';
        productHTML += '<div class="inner product-item" data-product-id="product-'+product.handle+'">';
        productHTML += '<div class="product-card__inner shape shape--default"><div class="product-card__images-wrapper multiply-mode">';
        productHTML +='<a href="'+product.url+'" class="product-grid-image" data-collections-related="/collections/all?view=related">';
        if (product.featured_image) {
            productHTML += '<img src="'+product.featured_image+'" alt="'+product.featured_image.alt+'">';
        }
        productHTML += '</a></div></div>';
        productHTML += '<div class="product-card__details product-card__details--bottom-spacing  product-card__details--left-spacing"><div class="product-card__info">';
        productHTML += '<a class="product-title" href="'+product.url+'" title="'+product.title+'">'+product.title+'</a>';
        productHTML += '<div class="column col-remove text-center">' +
                            '<a class="whislist-added" href="#" data-product-handle="'+ product.handle +'" button-wishlist data-id="'+ product.id +'"> Eliminar </a>' +
                        '</div></div>';
        productHTML += '</div></div></div>';
    });

    const productTileTemplateUrl = `/products/${handle}`;
    return fetch(productTileTemplateUrl)
        .then((res) => res.text())
        .then((res) => {
            return productHTML;
        })
        .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
    const wishlist = getWishlist();
    const requests = wishlist.map(fetchProductCardHTML);
    const responses = await Promise.all(requests);
    const wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    const event = new CustomEvent('shopify-wishlist:init-product-grid', {
        detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
    buttons.forEach((button) => {
        const productHandle = button.dataset.productHandle || false;
        if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
        if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);

        if (!button.dataset.hasClickEvent) {
        button.addEventListener('click', () => {
            updateWishlist(productHandle);
            button.classList.toggle(BUTTON_ACTIVE_CLASS);
        });
            button.dataset.hasClickEvent = 'true';
        }
    });
};

const initGrid = () => {
    const grid = document.querySelector(selectors.grid) || false;
    if (grid) setupGrid(grid);
};

const initButtons = () => {
    const buttons = document.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
    else return;
    const event = new CustomEvent('shopify-wishlist:init-buttons', {
        detail: { wishlist: getWishlist() }
    });
    document.dispatchEvent(event);
};

const getWishlist = () => {
    const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
    return [];
};

const setWishlist = (array, wasAdded) => {
    const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
    if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

    const event = new CustomEvent('shopify-wishlist:updated', {
        detail: { wishlist: array, wasAdded: wasAdded }
    });
    document.dispatchEvent(event);

    return wishlist;
};

const updateWishlist = (handle) => {
    const wishlist = getWishlist();
    const indexInWishlist = wishlist.indexOf(handle);
    let wasAdded = false;
    
    if (indexInWishlist === -1) {
        wishlist.push(handle); 
        wasAdded = true;
    } else {
     wishlist.splice(indexInWishlist, 1);
    }

    return setWishlist(wishlist, wasAdded);
};

const wishlistContains = (handle) => {
    const wishlist = getWishlist();
    return wishlist.includes(handle);
};

const resetWishlist = () => {
    return setWishlist([]);
};

// CUSTOM CODE WIM

document.addEventListener('DOMContentLoaded', () => {
    observeProductListUpdates();
});

function observeProductListUpdates() {
    const initObserver = (selector, callback) => { 
        const element = document.querySelector(selector);
        if (!element) {
            console.error(`El contenedor para el selector ${selector} no se encontró.`);
            return;
        }

        const observer = new MutationObserver(callback);
        observer.observe(element, { childList: true, subtree: true });
    };

    const commonCallback = (mutationsList, observer) => {
        initButtons(); 
        initGrid();
    };

    const selectors = [
        '#ShopProducts',
        '.product-recommendations',
        '#SearchSidebar'
    ];

    selectors.forEach(selector => initObserver(selector, commonCallback));
}

// END CUSTOM CODE WIM